const translateError = (error) => {
  const ERRORS = {
    'Invalid user or password': 'Email ou senha incorretos.',
    'User is not an analyst': 'Sem permissão ao sistema',
    default: 'Houve um erro no sistema, se persistir contacte o administrador',
  };
  return ERRORS[error] || ERRORS.default;
};
export default translateError;
